/** Routes rendered without the main site header/footer (embedded checkout). */
export function isBareTicketsRoute(pathname: string): boolean {
  return (
    /^\/events\/[^/]+\/tickets\/?$/.test(pathname) ||
    pathname === '/events/tickets/success' ||
    pathname === '/events/tickets/error'
  )
}
